import { ACTION_TYPES, useEmendasParlamentaresDispatch, useEmendasParlamentaresState } from "./emendas-parlamentares-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IEmendaParlamentarPagedRequest } from "models/request/emenda-parlamentar-paged-request";
import { downloadFile } from "utils/download-file";

export const useEmendasParlamentaresController = () => {
    const emendasDispatch = useEmendasParlamentaresDispatch();
    const { emendaPagedRequest } = useEmendasParlamentaresState();

    async function exportEmendas(format: string) {
        const file = await MunicipalPortalAAppService.exportEmendasParlamentares(emendaPagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IEmendaParlamentarPagedRequest;

        emendasDispatch({ type: ACTION_TYPES.setEmendaPagedRequest, payload: request });
        emendasDispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listEmendas(request);
        await loadLookups();

        emendasDispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [tipos, formasRepasse, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listTiposEmenda(),
                MunicipalPortalAAppService.listFormasRepasseEmenda(),
                MunicipalPortalAAppService.getEmendasParlamentaresUltimaAtualizacao()
            ]);
            emendasDispatch({ type: ACTION_TYPES.setTipos, payload: tipos });
            emendasDispatch({ type: ACTION_TYPES.setFormasRepasse, payload: formasRepasse });
            emendasDispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listEmendas(request: IEmendaParlamentarPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                emendasDispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            emendasDispatch({ type: ACTION_TYPES.setError, payload: null });

            const [emendas, totais] = await Promise.all([
                MunicipalPortalAAppService.listEmendasParlamentares(request),
                MunicipalPortalAAppService.getEmendasParlamentaresTotais({
                    term: request.term,
                    idTipoEmenda: request.idTipoEmenda,
                    idFormaRepasseEmenda: request.idFormaRepasseEmenda,
                    ano: request.ano,
                }),
            ]);

            emendasDispatch({ type: ACTION_TYPES.setEmendas, payload: emendas });
            emendasDispatch({ type: ACTION_TYPES.setTotais, payload: totais });
        } catch (error) {
            console.log(error);
            emendasDispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar as emendas parlamentares. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                emendasDispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...emendaPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listEmendas({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-tipo-id") {
            updated.idTipoEmenda = e.target.value;
        } else if (e.target.name === "select-forma-repasse-id") {
            updated.idFormaRepasseEmenda = e.target.value;
        } else if (e.target.name === "text-field-ano") {
            updated.ano = e.target.value ? Number(e.target.value) : undefined;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listEmendas({ ...updated, page: 0 }, true))();
        }

        emendasDispatch({ type: ACTION_TYPES.setEmendaPagedRequest, payload: updated });
    };

    return { listEmendas, handleOnChange, onInit, exportEmendas };
}
